import type { ReactElement } from 'react';
import { MicIcon } from './icons.js';

/**
 * Animación de descarte del take (paridad WhatsApp): el mic rojo de la barra
 * de grabación se lanza hacia arriba girando, un tachito aparece debajo con
 * la tapa abierta, el mic cae adentro, la tapa se cierra con un rebote y todo
 * se esfuma. Puro CSS (keyframes en ptt.css) — el caller lo monta al cancelar
 * y lo desmonta pasada la coreografía (~1.3s). Decorativo: aria-hidden,
 * pointer-events none, y oculto entero con prefers-reduced-motion.
 *
 * La tapa es un SVG SEPARADO del cuerpo para poder abrirla/cerrarla a
 * bisagra; el mic pasa POR DETRÁS del cuerpo del tacho (z-index) para que
 * "entre" de verdad.
 */
export function CancelSplash(): ReactElement {
  return (
    <span className="ptt-cancelsplash" aria-hidden="true">
      <span className="ptt-cs-mic">
        <MicIcon width={18} height={18} />
      </span>
      <span className="ptt-cs-trash">
        <svg
          className="ptt-cs-lid"
          width={20}
          height={7}
          viewBox="0 0 20 7"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
        >
          <path d="M1.5 5.5h17M7 5.5V2h6v3.5" />
        </svg>
        <svg
          className="ptt-cs-bin"
          width={20}
          height={16}
          viewBox="0 0 20 16"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
        >
          <path d="M2.5 1.5 4 14.5h12l1.5-13M7.8 5v6M12.2 5v6" />
        </svg>
      </span>
    </span>
  );
}
